export const DecimalConfig = {
  defaultPlaces: 6,
  minValue: 0.000001,
  minPlaces: 0.0,
};
